module.exports = __webpack_public_path__ + "static/media/narabahasa-logo.260bfb25.jpg";